import { BaseController } from '../../../../common/base/controller';
import { isNil } from 'lodash';

export class SidebarSectionController extends BaseController {
  constructor(controllerService, sidebarService, $scope) {
    'ngInject';
    super({ controllerService, sidebarService, $scope });
  }

  $onInit() {
    this.sidebarService.register(this);

    // Set properties of optional bindings
    if (!this.sectionTitle) {
      this.sectionTitle = this.name;
    }

    // Show flash message, if triggered
    this.$scope.$on('sidebar.showFlashMessage', (event, data) => {
      const className = this.getFlashMessageClassByType(data.type);
      this.flashMessage = {
        message: data.message,
        className,
      };
    });

    this.$scope.$on('sidebar.openSection', (event, section) => {
      if (this === section) {
        this.open();
      }
    });
  }

  $onDestroy() {
    this.resetSection();
  }

  get headerStatus() {
    const { status } = this;
    return isNil(status) ? null : `sidebar.section.status.${status}`;
  }

  getFlashMessageClassByType(type) {
    switch (type) {
      case 'success': {
        return 'alert-success';
      }
      case 'error': {
        return 'alert-danger';
      }
      default: {
        return 'alert-info';
      }
    }
  }

  resetSection() {
    // Remove maybe existing flashMessage
    this.flashMessage = null;
  }

  triggerClick() {
    // Ignore any click if this section is disabled
    if (this.disabled) {
      return;
    }

    if (angular.isFunction(this.action)) {
      this.sidebarService.closeSections();
      this.action();
    } else {
      this.toggle();
    }
  }

  toggle() {
    this.sidebarService.toggleSection(this);
    this.isOpen = !this.isOpen;
    this.resetSection();
  }

  open() {
    this.isOpen = true;
    this.resetSection();
  }

  close() {
    this.isOpen = false;
    this.resetSection();
  }
}
